import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Three-node share graph — one source on the left feeding two
 *  destinations on the right with thin connectors. The classic share
 *  silhouette; smaller dots than `IcnComment` so the trio doesn't
 *  dominate an eyebrow line. */
export function IcnShare(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="share">
      <circle cx="4" cy="8" r="1.6" />
      <circle cx="12" cy="4" r="1.6" />
      <circle cx="12" cy="12" r="1.6" />
      <line x1="5.5" y1="7.2" x2="10.5" y2="4.8" />
      <line x1="5.5" y1="8.8" x2="10.5" y2="11.2" />
    </Svg>
  );
}
